/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { billingProviderWebhookProviderPost } from '../fn/billing-provider-webhook/billing-provider-webhook-provider-post';
import { BillingProviderWebhookProviderPost$Params } from '../fn/billing-provider-webhook/billing-provider-webhook-provider-post';

@Injectable({ providedIn: 'root' })
export class BillingProviderWebhookApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `billingProviderWebhookProviderPost()` */
  static readonly BillingProviderWebhookProviderPostPath = '/billing/provider-webhook/{provider}';

  /**
   * Billing provider webhook.
   *
   * Endpoint used by billing providers to send subscription events.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `billingProviderWebhookProviderPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingProviderWebhookProviderPost$Response(params: BillingProviderWebhookProviderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = billingProviderWebhookProviderPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Billing provider webhook.
   *
   * Endpoint used by billing providers to send subscription events.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `billingProviderWebhookProviderPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  billingProviderWebhookProviderPost(params: BillingProviderWebhookProviderPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.billingProviderWebhookProviderPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
